import React, { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import Divider from '@mui/material/Divider';

import masterdataClassificationService from '../../service/masterdataClassification.service';
import { MasterDataClassificationFieldList } from '../../config/masterdataClassification';
import { CheckboxUI, FormLabelUI } from '../Interface';

const MasterdataClassificationTab = (props) => {
  const { values, validateField, setFieldValue } = useFormikContext();
  const { type, viewField } = props;
  const [fields, setFields] = useState(MasterDataClassificationFieldList);

  useEffect(() => {
    if (!type) {
      return;
    }
    getMasterdataClassification();
  }, [type]);

  const getMasterdataClassification = async () => {
    const names = await masterdataClassificationService.getClassificationByType(type);

    const updatedFields = MasterDataClassificationFieldList.map((field) => {
      const foundField = names.find((n) => n.field === field.value);
      return {
        ...field,
        label: foundField?.name ?? field.label,
      };
    });

    setFields(updatedFields);
  };

  return (
    <>
      {fields.map((field, idx) => (
        <React.Fragment key={field.value}>
          <Field
            name={field.value}
            type="checkbox"
            as={CheckboxUI}
            fullWidth
            label={<FormLabelUI text={field.label} />}
            disabled={viewField}
            checked={values[field.value] ?? false}
            onChange={async (e) => {
              await setFieldValue(field.value, e.target.checked);
              validateField(field.value);
            }}
          />
          {idx < fields.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </>
  );
};

export default MasterdataClassificationTab;
